

export const pageSections = Object.freeze({
	APIKey: "apiKey",
	TransactionalSMS: "transactionalSMS",
	TransactionalEmail: "transactionalEmail",
})